// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NodeInfoHeader_header__IJGst {
  display: flex;
  flex-direction: column;
}

.NodeInfoHeader_row__UVQ8g {
  display: flex;
  height: 24px;
}

.NodeInfoHeader_label__KEa9n {
  padding-left: 8px;
  width: 120px;
  font-weight: bold;
}

.NodeInfoHeader_name-box__2DMoE {
  display: flex;
  flex: 1 1;
  gap: 4px;
  align-items: center;
}
.NodeInfoHeader_name-box__2DMoE input {
  flex: 1 1;
}
.NodeInfoHeader_name-box__2DMoE i {
  cursor: pointer;
}

.NodeInfoHeader_edit-name-button__XW0J4 {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/NodeInfo/NodeInfoHeader.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;AACF;;AAEA;EACE,iBAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;AACF;AACE;EACE,SAAA;AACJ;AACE;EACE,eAAA;AACJ;;AAIA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADF","sourcesContent":[".header {\n  display: flex;\n  flex-direction: column;\n}\n\n.row {\n  display: flex;\n  height: 24px;\n}\n\n.label {\n  padding-left: 8px;\n  width: 120px;\n  font-weight: bold;\n}\n\n.name-box {\n  display: flex;\n  flex: 1;\n  gap: 4px;\n  align-items: center;\n}\n.name-box input {\n  flex: 1;\n}\n.name-box i {\n  cursor: pointer;\n}\n\n.edit-name-button {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `NodeInfoHeader_header__IJGst`,
	"row": `NodeInfoHeader_row__UVQ8g`,
	"label": `NodeInfoHeader_label__KEa9n`,
	"name-box": `NodeInfoHeader_name-box__2DMoE`,
	"edit-name-button": `NodeInfoHeader_edit-name-button__XW0J4`
};
export default ___CSS_LOADER_EXPORT___;
